import { IService } from '../services/types';

type WorkerOff = {
  date: number;
  fromTime: number;
  id: number;
  orderId: null | number;
  toTime: number;
  workerId: number;
} | any;

type ScheduleCard = {
  fromTime: number;
  toTime: number;
};

export const findRootCount = (arr: any[], value: any, key: string = 'id') => {
  let obj = arr.find(e => e[key] == value);
  let count = 0;

  if (!obj?.parent){
    return count;
  }

  while (obj?.parent){
    obj = arr.find(e => e[key] == obj?.parent?.id);
    ++count;
  }
  return count;
}
export const findAncestors = (arr: any[], value: any, key: string = 'id'): IService[] => {
  let obj = arr.find(e => e[key] == value);
  let ancestors = [obj];

  if (!obj?.parent){
    return ancestors;
  }

  while (obj?.parent){
    obj = arr.find(e => e[key] == obj?.parent?.id);
    ancestors.push(obj)
  }
  return ancestors;
}
export const findMainParent = (arr: any[], value: any, key: string = 'id'): IService => {
  let obj = arr.find(e => e[key] == value);

  if (!obj?.parent){
    return obj;
  }
  while (findRootCount(arr, obj.parent) > 3){
    obj = arr.find(e => e[key] == obj?.parent?.id);
  }
  return obj.parent;
}
export const extractChildren = (node: any, array: any[], index: number = 0, depth = 0) => {
  ++depth;

  const j = { ...node, title: node.title }

  array.push(j)

  if (j.attributes) {
    j.attributes.map(e => {
      return extractChildren(e, array, ++index, depth)
    })
  }
  return array;
}

export const formatPrice = (value: number | string) =>
  Intl.NumberFormat().format(value as number);

export const omit = (keys, obj) => {
  if (!keys.length) return obj
  const { [keys.pop()]: omitted, ...rest } = obj;
  return omit(keys, rest);
}
export function createSchedule(length: number, workerOff: WorkerOff[]) {
  const start = 8;
  const end = 23;

  const allHours: number[] = Array.from(
    {length: end - start + 1},
    (_, index) => index + start,
  );
  const busyHours: number[] = [];
  workerOff.forEach((item) => {
    let i = item.fromTime;
    while (i <= item.toTime) {
      busyHours.push(i);
      i++;
    }
  });
  const busySet = new Set(busyHours);

  const freeHours: number[] = allHours.filter((hour) => !busySet.has(hour));
  const freeHoursSet = new Set(freeHours);

  const scheduleCards: ScheduleCard[] = [];
  freeHours.forEach((hour) => {
    if (freeHoursSet.has(hour + length))
      scheduleCards.push({fromTime: hour, toTime: hour + length});
  });

  return scheduleCards;
}

export const isEmpty = (obj) => {
  return Object.keys(obj)?.length == 0;
}



export const persianNumToEn = (str: any) => str.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
export const enNumToPersian = (str: any) => str.toString().replace(/\d/g, x => ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'][x])